import { Asset, Entry } from 'contentful';
import Image from 'next/image';

type Feature = {
  description: string;
  image: Asset;
  title: string;
};

type Props = {
  title: string;
  subtitle: string;
  features: Entry<Feature>[];
};

export default function FeaturesBlock({ title, subtitle, features }: Props) {
  return (
    <section className="py-24">
      <div className="mx-auto mb-16 flex max-w-7xl flex-col items-center px-6">
        <h2 className="text-r-3xl max-w-2xl text-center font-bold">{title}</h2>
        <p className="text-r-lg m-auto mt-4 max-w-3xl  text-center">
          {subtitle}
        </p>
      </div>
      <div className="mx-auto flex max-w-2xl flex-col gap-8 px-6 md:flex-row lg:max-w-7xl">
        <div className="grid grid-cols-1 gap-10 pt-10 lg:grid-cols-3">
          {features.map((feature) => (
            <div
              className="flex flex-col items-center gap-4"
              key={feature.sys.id}
            >
              <Image
                src={`https:${feature.fields.image.fields.file.url}`}
                alt={feature.fields.title}
                width={100}
                height={100}
              />
              <div className="flex-1">
                <p className="mb-2 text-center text-3xl font-bold">
                  {feature.fields.title}
                </p>
                <p className="text-r-2xl text-center">
                  {feature.fields.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
